import { StyledOldCost as OldCost } from '@r1-frontend/ui-react/components/costs/OldCost/styled';

export default OldCost;
